import {Component, Input, ViewChild} from '@angular/core';
import {Table} from 'primeng/table';
import {BaseClientComponent} from '../../base-client.component';
import {AuditTrailService} from '../../../services/audit-trail.service';
import {AuditUtilsService} from '../../../services/audit-utils.service';
import {AuditEntry} from '../../../models/auditEntry';

@Component({
  selector: 'app-user-audit-history',
  templateUrl: './user-audit-history.component.html',
  styleUrls: ['./user-audit-history.component.scss']
})
export class UserAuditHistoryComponent extends BaseClientComponent {
  @Input() userUniqid: string;

  @ViewChild(Table) private table: Table;

  auditEntries: AuditEntry[] = [];
  totalItems = 0;
  pageSize = 25;
  page = 1;
  loading = false;
  unavailable = false;

  constructor(private auditTrailService: AuditTrailService,
              public auditUtilsService: AuditUtilsService) {
    super();
  }

  reload() {
    if (this.table) {
      this.table.reset();

      return;
    }
    this.page = 1;
    this.getAuditTrailOfUser();
  }

  loadLazy(event: any) {
    this.pageSize = event.rows;
    this.page = (event.first / event.rows) + 1;
    setTimeout(() => this.getAuditTrailOfUser());
  }

  private getAuditTrailOfUser() {
    if (!this.userUniqid) {
      return;
    }
    this.loading = true;
    const response$ = this.auditTrailService.getAuditTrailOfUser(this.userUniqid, this.page, this.pageSize)
      .subscribe({
        next: auditTrailPage => {
          this.auditEntries = auditTrailPage.items;
          this.totalItems = auditTrailPage.total;
          this.unavailable = false;
          this.loading = false;
        },
        error: () => {
          this.auditEntries = [];
          this.totalItems = 0;
          this.unavailable = true;
          this.loading = false;
        }
      });
    this.subscriptions.push(response$);
  }
}
